import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, CONTACT } from "./data";
import { scrollToId } from "./Reveal";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <motion.header
      data-testid="header-navbar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 inset-x-0 z-50 px-4 sm:px-6 pt-3"
    >
      <div className={`mx-auto max-w-7xl flex items-center justify-between rounded-full px-4 sm:px-6 py-2.5 transition-[background-color,box-shadow,border-color] duration-500 border ${scrolled ? "bg-white/75 backdrop-blur-xl border-white shadow-[0_10px_40px_-20px_rgba(11,17,32,0.35)]" : "bg-transparent border-transparent"}`}>
        <Logo />
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <button key={n.id} data-testid={`nav-link-${n.id}`} onClick={() => scrollToId(n.id)} className="relative text-sm text-[#0B1120]/80 hover:text-[#0B1120] transition-colors after:absolute after:left-0 after:-bottom-1 after:h-px after:w-full after:origin-left after:scale-x-0 after:bg-[#0B1120] after:transition-transform after:duration-300 hover:after:scale-x-100">
              {n.label}
            </button>
          ))}
        </nav>
        <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="nav-cta-whatsapp" className="inline-flex items-center gap-2 rounded-full bg-[#0B1120] text-white text-sm px-4 py-2 hover:bg-[#1F6F99] transition-colors">
          <MessageCircle className="w-4 h-4" /> <span className="hidden sm:inline">Scrie-ne</span><span className="sm:hidden">Contact</span>
        </a>
      </div>
    </motion.header>
  );
};
